module.exports = __webpack_public_path__ + "img/icon-visibility-off.f79786f5.svg";